import {z} from 'zod';

/**
 * Request schema for getting file as base64 from storage service
 */
export const storageFileRequestSchema = z.object({
  namespace: z.string().optional(),
  variantName: z.string().optional(),
});
